module.exports = __webpack_public_path__ + "img/staffNavIcon.79667db7.svg";